export default "/template/resource//static/media/img_tongyong@2x.a742cc56.png";